import { memo } from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { MAX_PAYMENT_INSTALMENTS_WITH_FEES_DISPLAYED, PAYMENT_TERMS } from "app/constants";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";

import "./Total.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const Total = ({
	total,
	isPagePayment = false,
	paymentMode,
	isLoading,
	taxesAndFeesIncluded = false,
}) => {
	const shouldNotHighlightAmount =
		paymentMode !== PAYMENT_TERMS["1x"] &&
		paymentMode <= MAX_PAYMENT_INSTALMENTS_WITH_FEES_DISPLAYED;

	const totalAmountClass = classNames({
		"total__value total__price-detail-item": true,
		"total__value--small": shouldNotHighlightAmount && isPagePayment,
	});

	return (
		<div className="total" data-testid="booking-total">
			<div className="total__label">
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} isBold component={"span"}>
					<FormattedMessage id="price.detail.total.label" />
				</Typography>
				{taxesAndFeesIncluded && (
					<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} component={"span"}>
						<div className="total__label--note">
							(<FormattedMessage id="general.all.taxes.and.fees.included.label" />)
						</div>
					</Typography>
				)}
			</div>
			<div className={totalAmountClass}>
				{isLoading && isPagePayment ? (
					<LoaderBar width={80} />
				) : (
					<AmountContainer amount={total} />
				)}
			</div>
		</div>
	);
};

Total.propTypes = {
	total: PropTypes.number,
	isPagePayment: PropTypes.bool,
	paymentMode: PropTypes.number,
	isLoading: PropTypes.bool,
	taxesAndFeesIncluded: PropTypes.bool,
};

export default memo(Total);
